import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_MFA_SETUP_SMS_RESEND } from "consts";

export default function useMfaSetupSmsResend(config) {
  return useMutation(
    ({ accessToken }) =>
      postWithBearer(API_MFA_SETUP_SMS_RESEND, {}, accessToken),
    config
  );
}
